import { Observable } from "rxjs";
import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LanguageService {
  public langSubject: BehaviorSubject<string>;
  public lang: Observable<string>;

  constructor() {
    this.langSubject = new BehaviorSubject<string>("default");
    this.lang = this.langSubject.asObservable();
    this.startup_lang();
  }

  startup_lang() {
    let lang = sessionStorage.getItem("used_lang");
    if (lang) {
      this.langSubject.next(lang);
    } else {
      this.langSubject.next("default");
    }
  }

  public switchLang(lang: string) {
    this.langSubject.next(lang);
    sessionStorage.setItem("used_lang", lang);
  }
}
